<template>

  <div class="feed-content">
    <div class="content">
      
      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
          </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="deleteMeetinsight(meetinsight._id)">
            <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div><strong>{{ $t('Meeting analysis') }}</strong></div>

      <div class="mt-2">
        <div><span class="text-muted">{{ $t('Start date') }}:</span> {{ $d(new Date(meetinsight.start_date), 'long') }}</div>
        <div><span class="text-muted">{{ $t('Duration') }}:</span> {{ meetinsight.duration_time }}</div>
        <div><span class="text-muted">{{ $t('Participants') }}:</span> {{ meetinsight.max_participants }}</div>
      </div>

      <div
        v-if="meetinsight.analysis_impossible"
        class="mt-3">
        <h6>{{ $t('Não foi possível fazer a análise da entrevista') }}</h6>
        <p>{{ meetinsight.reason_impossible }}</p>
      </div>
      <div v-else-if="analysis_data">
        <div>
          <div
            v-if="analysis_data.technical_fit"
            class="my-3"
            style="white-space: pre-wrap;">{{ analysis_data.technical_fit }}</div>
          <div
            v-if="meetinsight.analysis"
            class="my-3"
            style="white-space: pre-wrap;">{{ meetinsight.analysis }}</div>
        </div>
        <div v-if="showAll">
          <div
            v-if="analysis_data.communication"
            class="my-3">
            <h6>Comunicação e tom emocional</h6>
            <div style="white-space: pre-wrap;">{{ analysis_data.communication }}</div>
          </div>
          <div
            v-if="analysis_data.behavioral_competencies"
            class="my-3">
            <h6>Comportamento e cultura</h6>
            <div style="white-space: pre-wrap;">{{ analysis_data.behavioral_competencies }}</div>
          </div>
          <div 
            v-if="analysis_data.strengths.length"
            class="my-3">
            <h6>Pontos fortes</h6>
            <ul class="list-group">
              <li
                class="list-group-item"
                v-for="(item, index) in analysis_data.strengths"
                :key="index">
                {{ item }}
              </li>
            </ul>
          </div>
          <div
            v-if="analysis_data.weaknesses.length"
            class="my-3">
            <h6>Pontos fracos</h6>
            <ul class="list-group">
              <li
                class="list-group-item"
                v-for="(item, index) in analysis_data.weaknesses"
                :key="index">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="showAll">
        <div class="form-group">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="showTranscription"
              v-model="showTranscription">
            <label
              class="form-check-label"
              for="showTranscription">
              {{ $t('Show transcription') }}
            </label>
          </div>
        </div>
        <div
          v-if="showTranscription">
          <div class="text-muted mb-2">
            <p><i>A transcrição é gerada automaticamente por inteligência artificial a partir do áudio da reunião. Em alguns momentos, principalmente no início ou quando a qualidade do som está baixa (com ruídos, falas sobrepostas ou microfones distantes), a transcrição pode exibir caracteres estranhos ou frases confusas.</i></p>
            <p><i>Isso é esperado e, normalmente, a IA ajusta o padrão de reconhecimento conforme a conversa avança.</i></p>
            <p><i>Além disso, a inteligência artificial que analisa as transcrições já está preparada para lidar com esses ruídos e imprecisões pontuais.</i></p>
          </div>
          <table>
            <tbody>
              <tr
                v-for="(cue, index) in transcriptionCues"
                :key="index">
                <td width="90" class="text-muted">{{ cue.start }} - {{ cue.end }}</td>
                <td width="10"></td>
                <td v-html="cue.text.replace('</v>', '</v> ')"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <a
        href="javascript:void(0)"
        @click="showAll=!showAll">
        {{ showAll ? $t('Show less') : $t('Show more') }}
        </a>
    </div>
  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'
import moment from 'moment'

export default {
  name: 'CandidateQualificationItem',
  components: {
    Avatar
  },
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showAll: false,
      showTranscription: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.author_user.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    },
    meetinsight () {
      return this.activity.meetinsight || {}
    },
    transcriptionCues () {
      const rows = this.meetinsight.transcription_cues || []
      return rows.map((cue) => {
        return {
          start: moment().startOf('day').set({ second: cue.start }).format('mm:ss'),
          end: moment().startOf('day').set({ second: cue.start }).format('mm:ss'),
          text: cue.text
        }
      })
    },
    analysis_data () {
      return this.meetinsight.analysis_data || null
    }
  },
  created () {
  },
  methods: {
    deleteMeetinsight (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteMeetinsight', id)
        .then((result) => {
          return this.$store
          .dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedMeetinsightItem.vue